import { ApiProperty } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsBoolean, IsString, IsUUID } from 'class-validator';
import { CommonEntityDto } from '../../../common/dto/common-entity.dto';
import { BuilderDto } from '../../../builder/dto/builder.dto';
import { SpBuilderBoardTypeInterface } from '../interfaces/sp-builder-board-type.interface';
import { BoardTypeDto } from '../../../board-type/dtos/board-type.dto';

export class SpBuilderBoardTypeDto
  extends CommonEntityDto
  implements SpBuilderBoardTypeInterface
{
  @ApiProperty({ required: true })
  @IsString()
  itemDescription!: string;

  @ApiProperty({ type: 'string' })
  itemDescriptionId!: string;

  @ApiProperty({ required: true })
  @IsUUID()
  builderId!: string;

  @ApiProperty({ required: true })
  @IsUUID()
  boardTypeId!: string;

  @ApiProperty({
    type: 'boolean',
    default: true,
    title: 'Active?',
    description: 'True if builder board type is active',
  })
  @IsBoolean()
  active!: boolean;

  @ApiProperty({ type: BuilderDto })
  @Type(() => BuilderDto)
  builder?: BuilderDto;

  @ApiProperty({ type: BoardTypeDto })
  @Type(() => BoardTypeDto)
  boardType?: BoardTypeDto;
}
